// @ngInject
function StockLogisticsApiService($q, DS, DSHttpAdapter, ResourcesService) {

    var endpoint = 'stocklogistics';

    return {
        getByArticle: getByArticle,
        saveStockLogistics: saveStockLogistics,
        generateAutoOrders: generateAutoOrders,
        getByArticlesVariants: getByArticlesVariants,
        getArticleCollections: ResourcesService.apiFactory.get(endpoint + '/articlecollections'),
        getLocations: ResourcesService.apiFactory.get(endpoint + '/locations'),
        getProduct: ResourcesService.apiFactory.get(endpoint + '/products'),
        getProductsForMassHandingOrderingPoints: getProductsForMassHandingOrderingPoints
    };

    function getByArticle(articleId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + '/stocklogistics/articles/' + articleId).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getByArticlesVariants(articleVariantIds) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + '/stocklogistics/articleVariants/', articleVariantIds).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function saveStockLogistics(stockLogistics) {
        var deferred = $q.defer();

        var jsonRequest = JSON.stringify(stockLogistics);

        DSHttpAdapter.POST(DS.defaults.basePath + '/stocklogistics', jsonRequest).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function generateAutoOrders() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'stocklogistics/createautoorders').then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getProductsForMassHandingOrderingPoints(selectedLocations, selectedMaingroups, selectedBrands, selectedCollections, selectedIsCurrent){
        var deferred = $q.defer();

        var request = {
            locationIds : [],
            mainGroupIds : [],
            brandIds : [],
            collectionIds : [],
            includeIsCurrent : selectedIsCurrent
        }

        _.forEach(selectedLocations, function(location){
            request.locationIds.push(location.id);
        });
        _.forEach(selectedMaingroups, function(mainGroup){
            request.mainGroupIds.push(mainGroup.id);
        });
        _.forEach(selectedBrands, function(brand){
            request.brandIds.push(brand.id);
        });
        _.forEach(selectedCollections, function(collection){
            request.collectionIds.push(collection.id);
        });

        DSHttpAdapter.POST(DS.defaults.basePath + '/stocklogistics/masshandlingorderingpoints/products', request).then(function(response){
            deferred.resolve(response);
        }, function(error){
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('stocklogistics.api', [])
    .factory('StockLogisticsApiService', StockLogisticsApiService);
